(function (window, $) {
  const $modal = $('#tournament-modal');

  if (!$modal.length) {
    return;
  }

  let selectedTeamId = null;
  let selectedTeamName = null;
  let selectedTeamImage = null;

  const updateConfirmButton = function () {
    const $studio = $modal.find('.js-tournament-studio');
    const studioOk = !$studio.length || !!$studio.val();
    $modal.find('.js-tournament-confirm').prop('disabled', !selectedTeamId || !studioOk);
  };

  const showModal = function () {
    $modal.show();
    $('body').addClass('modal-open');
  };

  const hideModal = function () {
    $modal.hide();
    $('body').removeClass('modal-open');
  };

  const goToStep = function (step) {
    $modal.find('.tournament-modal__step').removeClass('tournament-modal__step--active');
    $modal.find('.tournament-modal__step[data-step="' + step + '"]').addClass('tournament-modal__step--active');

    if (step === 2) {
      $modal.find('.tournament-modal__teams').removeClass('tournament-modal__teams--hidden');
      $modal.find('.tournament-modal__search-icon').show();
      $modal.find('.js-tournament-search-flag').prop('hidden', true);
      $modal.find('.js-tournament-search').val('').focus();
      $modal.find('.js-tournament-team').show();
    }
  };

  const bindEvents = function () {
    $modal.on('click', '.js-tournament-next', function () {
      goToStep(2);
    });

    $modal.on('click', '.js-tournament-skip', function () {
      var csrf_token = $modal.find('[name="csrf_token"]').first().val();
      $.post('/tournament/skip/', { csrf_token: csrf_token });
      hideModal();
    });

    $modal.on('click', '.js-tournament-close', function () {
      hideModal();
    });

    $modal.on('keydown', function (e) {
      if (e.key === 'Escape') {
        hideModal();
      }
    });

    $modal.on('input', '.js-tournament-search', function () {
      const query = $(this).val().toLowerCase().trim();
      const $teams = $modal.find('.tournament-modal__teams');

      $teams.removeClass('tournament-modal__teams--hidden');
      $modal.find('.js-tournament-search').removeClass('has-value');
      $modal.find('.tournament-modal__search-icon').show();
      $modal.find('.js-tournament-search-flag').prop('hidden', true);

      if (!query) {
        selectedTeamId = null;
        selectedTeamName = null;
        selectedTeamImage = null;
        $modal.find('.js-tournament-team-id').val('');
        $modal.find('.tournament-modal__cta-block [type="submit"]').prop('disabled', true);
      }

      $modal.find('.js-tournament-team').each(function () {
        const name = $(this).data('team-name').toLowerCase();

        $(this).toggle(!query || name.indexOf(query) !== -1);
      });
    });

    $modal.on('click', '.js-tournament-team', function () {
      selectedTeamId = $(this).data('team-id');
      selectedTeamName = $(this).data('team-name');
      selectedTeamImage = $(this).data('team-image') || null;

      $modal.find('.js-tournament-team').removeClass('tournament-modal__team-option--selected');
      $(this).addClass('tournament-modal__team-option--selected');

      const teamFlag = $(this).data('team-flag');

      $modal.find('.js-tournament-search').val(selectedTeamName).addClass('has-value');
      $modal.find('.tournament-modal__search-icon').hide();
      $modal.find('.js-tournament-search-flag').text(teamFlag).prop('hidden', false);
      $modal.find('.tournament-modal__teams').addClass('tournament-modal__teams--hidden');

      $modal.find('.js-tournament-team-id').val(selectedTeamId);
      updateConfirmButton();
    });

    $modal.on('change', '.js-tournament-studio', function () {
      updateConfirmButton();
    });

    $modal.on('click', '.js-tournament-done', function () {
      hideModal();
    });

    $modal.on('submit', '.js-tournament-form', function (e) {
      e.preventDefault();

      const $form = $(this);
      const $btn = $form.find('[type="submit"]');
      const $error = $modal.find('.js-tournament-error');

      $btn.prop('disabled', true);
      $error.prop('hidden', true);

      $.ajax({
        url: '/tournament/select-team/',
        method: 'POST',
        data: $form.serialize(),
        dataType: 'json',
        success: function () {
          $modal.find('.js-tournament-selected-team-name').text(selectedTeamName.toUpperCase());

          const $img = $modal.find('.js-tournament-confirmation-image');

          if (selectedTeamImage) {
            $img.attr('src', selectedTeamImage).attr('alt', selectedTeamName).prop('hidden', false);
          } else {
            $img.prop('hidden', true);
          }

          $('.js-open-tournament-modal').hide();
          goToStep(3);
        },
        error: function (xhr) {
          if (xhr.status === 401) {
            window.location.href = '/login/?redirect=' + encodeURIComponent(window.location.pathname);
            return;
          }

          let message = 'Something went wrong. Please try again.';

          if (xhr.responseJSON && xhr.responseJSON.error) {
            message = xhr.responseJSON.error;
          }

          $error.text(message).prop('hidden', false);
          $btn.prop('disabled', false);
        }
      });
    });
  };

  $(document).ready(function () {
    bindEvents();
    // Auto-launch the modal on page load only if not previously dismissed
    if (!$modal.data('dismissed')) {
      showModal();
    }
  });

  // open modal when CTA clicked
  $(document).on('click', '.js-open-tournament-modal', function (e) {
    e.preventDefault();
    showModal();
    // jump directly to team picker
    goToStep(2);
  });
})(window, jQuery);
